"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = exports.clearData = exports.setData = exports.flatPropsList = exports.fixAndMergeSchema = exports.wrap = exports.polyfills = exports.JSchema = exports.WrappedPropertyCtor = exports.schemaMethods = exports.schemaMixin = void 0;
var JSchema_1 = require("./JSchema/JSchema");
exports.JSchema = JSchema_1.default;
var validate_1 = require("./JSchema/validate");
exports.validate = validate_1.default;
var schemaMixin_1 = require("./schemaMixin");
exports.schemaMixin = schemaMixin_1.default;
var schemaMethods_1 = require("./schemaMethods");
exports.schemaMethods = schemaMethods_1.default;
// tslint:disable-next-line: no-var-requires
// const polyfills = require('./polyfills.ts');
var polyfills = require("./polyfills");
exports.polyfills = polyfills;
var WrappedProperty_1 = require("./WrappedProperty");
exports.WrappedPropertyCtor = WrappedProperty_1.default;
Object.defineProperty(exports, "wrap", { enumerable: true, get: function () { return WrappedProperty_1.wrap; } });
var fixAndMergeSchema_1 = require("./JSchema/fixAndMergeSchema");
exports.fixAndMergeSchema = fixAndMergeSchema_1.default;
var flatPropsList_1 = require("./JSchema/flatPropsList");
exports.flatPropsList = flatPropsList_1.default;
var setData_1 = require("./JSchema/setData");
exports.setData = setData_1.default;
var clearData_1 = require("./JSchema/clearData");
exports.clearData = clearData_1.default;
exports.default = JSchema_1.default;
//# sourceMappingURL=index.js.map